var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMathsAddSvgrepoCom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00D7DF"
    },
    d: "M256,512C114.839,512,0,397.161,0,256S114.839,0,256,0s256,114.839,256,256S397.161,512,256,512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00B6BD"
    },
    d: "M512,256C512,114.839,397.161,0,256,0v512C397.161,512,512,397.161,512,256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M362.273,149.727c-6.523-6.523-17.091-6.523-23.614,0L149.727,338.659 c-6.523,6.517-6.523,17.096,0,23.614c3.262,3.262,7.535,4.893,11.806,4.893c4.272,0,8.546-1.631,11.806-4.893l188.932-188.932 C368.796,166.822,368.796,156.245,362.273,149.727z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFEB99"
    },
    d: "M338.659,149.727L256,232.386v47.228l106.273-106.273c6.523-6.517,6.523-17.096,0-23.614 C355.75,143.204,345.182,143.204,338.659,149.727z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFEB99"
    },
    d: "M389.594,328.364H278.266c-9.225,0-16.699,7.475-16.699,16.699s7.475,16.699,16.699,16.699h111.329 c9.225,0,16.699-7.475,16.699-16.699S398.819,328.364,389.594,328.364z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M161.371,222.601c0,9.225,7.475,16.699,16.699,16.699c9.225,0,16.699-7.475,16.699-16.699v-38.965 h38.965c9.225,0,16.699-7.475,16.699-16.699s-7.475-16.699-16.699-16.699h-38.965v-38.965c0-9.225-7.475-16.699-16.699-16.699 c-9.225,0-16.699,7.475-16.699,16.699v38.965h-38.965c-9.225,0-16.699,7.475-16.699,16.699s7.475,16.699,16.699,16.699h38.965 V222.601z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMathsAddSvgrepoCom);
export default __webpack_public_path__ + "static/media/maths-add-svgrepo-com.699051312a9e69b7e6d0ee1c5d95b624.svg";
export { ForwardRef as ReactComponent };